import React from "react";
import { Box } from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import SearchInput from "app/components/SearchInput";
import { useTranslation } from "react-i18next";
import EditorsSelect from "app/components/EditorSelect";
import { useNavigate, useSearchParams } from "react-router-dom";
import { LEFT_SPACING } from "utils/constants";

const Header = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const searchParams  = useSearchParams();
  const editorParam = searchParams?.[0]?.get("user");
  
  const setEditorSearchQuery = (search: string) => {
    const params = new URLSearchParams(window.location.search);
    if (search.toLowerCase() == "all") {
      params.set("user", "");
    } else {
      params.set("user", search);
    }
    navigate(`?${params.toString()}`);
  };
  return (
    <Grid2 container spacing={2} md={12}  sx={{marginTop: '-32px'}} paddingLeft={LEFT_SPACING}>
      <Grid2 xs={12} md={4}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
            height: "100%",
            paddingBottom: "10px",
          }}
        >
          <SearchInput />
        </Box>
      </Grid2>
      <Grid2 xs={6} md={3}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
            height: "100%",
          }}
        >
          <EditorsSelect 
            label={t("COMMON.LABELS.EDITOR_NAME")}
            isFieldReq={false}
            backgroundColor="#F3F6F8"
            borderWidth={0}
            onChange={(e) => setEditorSearchQuery(e?.value||"")}
            value={editorParam ? {value: editorParam, label: ''} : undefined}
          />
        </Box>
      </Grid2>
    </Grid2>
  );
};

export default Header;
